import { Expose, Type } from '@nts/std/serialization';
import { LayoutDefinitionIdentity } from './layout-definition.identity';
import { BaseLayoutDataDtoInterface, LayoutDefinitionIdentityInterface } from '@nts/std/interfaces';

export class BaseLayoutDataDto implements BaseLayoutDataDtoInterface {

    @Expose()
    @Type(() => LayoutDefinitionIdentity)
    layoutIdentity?: LayoutDefinitionIdentityInterface;

    @Expose()
    serviceFullName?: string;

}
